import { IProductCard } from '@src/components/product-card/product-card.types'
import {
  getNonProductBasedRecommendationId,
  RECOMMENDED_PRODUCTS_TYPE,
} from '@src/quince-site-pdp/src/organisms/productPageSections/utils'

import { ERecommendationToCollectionMapper } from '../../domains/Product/ProductRecommendation'
import { getlbUserId } from '../../utils/getlb-user-id'

function getCollectionIdBasedOnFirstProductCard(
  firstProductCard: IProductCard | undefined,
  isfirstProductCardReq: boolean,
  recommendationCollectionIdMapper: ERecommendationToCollectionMapper,
  initialCollectionId: string,
) {
  if (isfirstProductCardReq && !firstProductCard) {
    return getNonProductBasedRecommendationId(
      recommendationCollectionIdMapper,
      RECOMMENDED_PRODUCTS_TYPE.CUSTOMER_TOP_PRODUCTS,
    )
  }
  return initialCollectionId
}
function getLbUserIDForCustomerTopProducts(recommendedProductsType: RECOMMENDED_PRODUCTS_TYPE) {
  const lbUserId = getlbUserId()
  if (lbUserId && recommendedProductsType === RECOMMENDED_PRODUCTS_TYPE.CUSTOMER_TOP_PRODUCTS) {
    return lbUserId
  }
  return ''
}
function getProductRecommendationOptionsForMTEandQSAL(
  isfirstProductCardReq: boolean,
  productCards: IProductCard[],
  colorOfFirstProductCard: string | undefined,
): { colorForProductRecommendations?: string; productIdForRecommendations?: string | number } {
  return isfirstProductCardReq
    ? {
        colorForProductRecommendations: colorOfFirstProductCard,
        productIdForRecommendations: productCards?.[0]?.product.productId,
      }
    : {}
}

export {
  getCollectionIdBasedOnFirstProductCard,
  getLbUserIDForCustomerTopProducts,
  getProductRecommendationOptionsForMTEandQSAL,
}
